import { Routes, Route, Navigate } from 'react-router-dom';
import { LandingPage } from '@/modules/landing/presentation/pages/LandingPage';
import {
  ENSAIO_RESULT_PATH,
  SimuladoPage,
} from '@/modules/simulado/presentation/pages/SimuladoPage';
import { GabaritoPage } from '@/modules/gabarito/presentation/pages/GabaritoPage';
import { PainelPage } from '@/modules/painel/presentation/pages/PainelPage';

/**
 * Cada build serve uma prova e uma edição (`VITE_TENANT` + `VITE_EDITION_*`),
 * no seu próprio site. Os dois caminhos de entrada:
 *
 * - **antes da prova**: LP → `/ensaio` → cadastro ou login (diálogo) →
 *   diagnóstico no painel;
 * - **depois da prova**: LP → `/gabarito` → "já tem conta?" → login ou
 *   cadastro → correção no painel.
 *
 * Login e cadastro não têm rota, como no `enamed-feedback-lp`: abrem por cima
 * da tela de onde a pessoa veio.
 */
export function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/ensaio" element={<SimuladoPage />} />
      <Route path="/gabarito" element={<GabaritoPage />} />
      <Route path="/minha-conta" element={<PainelPage />} />
      {/* O diagnóstico do ensaio virou sub-aba do painel; links antigos
          chegam lá. */}
      <Route
        path="/diagnostico"
        element={<Navigate to={ENSAIO_RESULT_PATH} replace />}
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
